import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSeo } from '@/hooks/useSeo';

export default function CheckoutCancelPage() {
  useSeo({
    title: 'Pagamento annullato',
    description: "Il pagamento è stato annullato. Il carrello è ancora disponibile per completare l'acquisto.",
    path: '/checkout/cancel',
    noindex: true,
  });

  return (
    <div className="bg-ivory pt-24 md:pt-28 min-h-screen flex items-center justify-center" data-testid="checkout-cancel-page">
      <div className="max-w-lg mx-auto px-6 py-20 text-center">
        <div className="w-16 h-16 border border-line rounded-full flex items-center justify-center mx-auto mb-8">
          <XCircle className="w-8 h-8 text-muted" strokeWidth={1.25} />
        </div>
        <h1 className="font-display text-h2 text-ink mb-4">Pagamento Annullato</h1>
        <p className="text-muted leading-relaxed mb-10 max-w-md mx-auto">
          Il tuo pagamento è stato annullato. Il carrello è stato salvato e puoi completare
          l'acquisto in qualsiasi momento.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/carrello" data-testid="back-to-cart">
            <Button size="lg" variant="accent" className="w-full sm:w-auto">
              <ArrowLeft className="w-4 h-4 mr-1" />
              Torna al Carrello
            </Button>
          </Link>
          <Link to="/collezione" data-testid="continue-shopping">
            <Button size="lg" variant="outline" className="w-full sm:w-auto">
              Continua lo Shopping
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
